import auth from '@client/components/auth';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Influencer } from '../components/CommunityToggleModal';

export const useCommunityUser = (influencerId?: string) => {
  const isAdmin = auth.isAdministrator();
  const creatorId = isAdmin
    ? Number(influencerId)
    : auth.getUser().influencerId;
  const [influencer, setInfluencer] = useState<Influencer>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchInfluencer = () => {
    auth
      .getInfluencerById(Number(creatorId))
      .then((user) => {
        setInfluencer(user as Influencer);
      })
      .catch(() => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!creatorId) {
      toast.error('Creator id is missing');
    } else {
      setIsLoading(true);
      fetchInfluencer();
    }
  }, []);

  return {
    influencer,
    isLoading,
    fetchInfluencer,
  };
};
